import {
  AssessmentButton,
  AssessmentCheckboxRadio,
  InputField,
  MultiSelector,
  RangeSelector,
  RightSidePanel,
  showToast,
  TemplateSearch,
  TextEditor,
  Tooltip,
} from "ui-components";
import "./ScanningDetails.scss";
import { useTranslation } from "react-i18next";
import {
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import AddressField from "./AddressField/AddressField";
import { systemPreferenceContext } from "../../../../context/SystemPreference/SystemPreference";
import useDebounce from "../../../../utils/Hooks/useDebounce";
import { getSessionStorageItem } from "../../../../utils/SessionStorageMethod/getSessionStorageItem";
import {
  getDefaultSkill,
  getIndustrySkillMapping,
} from "../../../../service/Scope/Scope";
import { setSessionStorageItem } from "../../../../utils/SessionStorageMethod/setSessionStorageItem";
import CircleCrossIcon from "../../../../utils/Images/CircleCrossIcon";
import EngagementType from "../../../Assessment/sections/AssessmentSetting/AdvanceSetting/EngagementType";
import JobTypeSelector from "../../../Assessment/sections/AssessmentSetting/AdvanceSetting/JobTypeSelector";
import { forwardRef } from "react";
import {
  calculateMinusAmount,
  capitalizeFirstLetter,
  formatAddressField,
  removeFromQueryParams,
  setInQueryParams,
  transformJobDetails,
  typesKeyPair,
  updateSessionStorage,
  validateShiftTime,
} from "../../../../utils/Common/Constant";
import ShiftTime from "../../../Assessment/sections/AssessmentSetting/AdvanceSetting/ShiftTime";
import Budget from "../../../Assessment/sections/AssessmentSetting/AdvanceSetting/Budget";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getCurrencyList } from "../../../../service/CvScanning/CvScanning";
import DownArrow from "../../../../utils/Images/DownArrow";
import PlusIcon from "../../../../utils/Images/PlusIcon";
import { JobScreensEnums } from "../../../../utils/Enums/JobScreensEnums";
import Loader from "../../../../components/Loader/Loader";
import DataNotAvailable from "../../../../utils/DataNotFound/DataNotAvailable";
const ScanningDetails = forwardRef(
  ({ jobDetailsData, scrollingRef }: any, ref) => {
    const { t } = useTranslation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const titleInputRef = useRef<HTMLInputElement>(null);
    const { preferenceData } = useContext(systemPreferenceContext);
    const [getSkillList, setGetSkillList] = useState<any>([]);
    const [searchSkillTerm, setSearchSkillTerm] = useState("");
    const [addSkillModal, setAddSkillModal] = useState(false);
    const [keywordText, setKeywordText] = useState<string>("");
    const [isTaxChecked, setIsTaxChecked] = useState(
      getSessionStorageItem("isTaxChecked") ?? false,
    );
    const [addedKeywordText, setAddedKeywordText] = useState<any>(
      (getSessionStorageItem("job-keywords")?.length &&
        getSessionStorageItem("job-keywords")?.split(",")) ||
        [],
    );
    const [maxBudget, setMaxBudget] = useState(null);
    const [minBudget, setMinBudget] = useState(null);
    const [categorySkills, setCategorySkills] = useState<any>([]);
    const [category, setCategory] = useState<any>([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState<any>([]);
    const [currencyList, setCurrencyList] = useState([
      { value: "", label: "" },
    ]);
    const [selectedCurrency, setSelectedCurrency] = useState<any>("");
    const [seachParams] = useSearchParams();
    const [locationPopupOpen, setLocationPopupOpen] = useState(
      seachParams.get("lp") === "true" ? true : false,
    );
    const [categoryCurrentPage, setCategoryCurrentPage] = useState(1);
    const categoryPageSize = 30;
    const [editAddressDetails, setEditAddressDetails] = useState<any>(null);
    const [additionalNoteText, setAdditionalNoteText] = useState(
      getSessionStorageItem("jobAdditionalNotes") ?? "",
    );
    const [showAboveInfo, setShowAboveInfo] = useState(false);
    const textEditorLimit = 1001;
    const jobDescriptionLimit = 5001;
    const [countAdditionalNoteInEditor, setCountAdditionalNoteInEditor] =
      useState(0);
    const [additionalCountManageFlag, setAdditionalCountManageFlag] =
      useState(false);
    const [descriptionCountManageFlag, setDescriptionCountManageFlag] =
      useState(false);
    const [descriptionText, setDescriptionText] = useState(
      getSessionStorageItem("jobDescription") ?? "",
    );
    const [countDescriptionInEditor, setCountDescriptionInEditor] = useState(0);
    const [addedSkillList, setAddedSkillList] = useState<any>(
      jobDetailsData?.jobSkills ?? getSessionStorageItem("jobSkills") ?? [],
    );
    const [titleText, setTitleText] = useState<string>(
      getSessionStorageItem("jobTitle") ?? "",
    );
    const [titleRequire, setTitleRequire] = useState(false);
    const debounceSkillSearchValue = useDebounce(searchSkillTerm, 500);
    const [jobType, setJobType] = useState({
      engagementType:
        getSessionStorageItem("advanceSettingData")?.jobType ??
        JobScreensEnums.JOB_TYPE_FULLTIME,
      jobType:
        getSessionStorageItem("advanceSettingData")?.engagementType ??
        JobScreensEnums.JOB_TYPE_ONSITE,
    });
    const systemPreferenceData = preferenceData?.createAssessment;
    const [experienceMinValue, setExperienceMinValue] = useState<number>(
      preferenceData?.createAssessment?.minimumExperience !== undefined
        ? getSessionStorageItem("minimumExperience") === null
          ? Number(preferenceData.createAssessment.minimumExperience)
          : getSessionStorageItem("minimumExperience")
        : getSessionStorageItem("minimumExperience"),
    );
    const [experienceMaxValue, setExperienceMaxValue] = useState<number>(
      preferenceData?.createAssessment?.maximumExperience !== undefined
        ? getSessionStorageItem("maximumExperience") ||
            Number(preferenceData.createAssessment.maximumExperience)
        : getSessionStorageItem("maximumExperience"),
    );
    const [noOfPositions, setNoOfPositions] = useState<number>(
      preferenceData?.createAssessment?.noOfPositions !== undefined
        ? getSessionStorageItem("noOfPositions") ||
            Number(preferenceData.createAssessment.noOfPositions)
        : getSessionStorageItem("noOfPositions"),
    );
    const [startTime, setStartTime] = useState(
      jobDetailsData?.shiftStartTime?.split(" ")[0],
    );
    const [endTime, setEndTime] = useState(
      jobDetailsData?.shiftEndTime?.split(" ")[0],
    );
    const [startMeridiem, setStartMeridiem] = useState("AM");
    const [endMeridiem, setEndMeridiem] = useState("PM");
    const [addressField, setAddressField] = useState<any[]>(
      getSessionStorageItem("jobMutipleAddress") || [],
    );
    const [skillsCurrentPage, setSkillsCurrentPage] = useState(1);
    const skillsPageSize = 20;
    const skillsListRef = useRef<HTMLDivElement | null>(null);
    const [skillsCount, setSkillsCount] = useState(0);
    const firstInputRef = useRef<HTMLInputElement>(null);
    const [skillLoader, setSkillLoader] = useState(true);
    useEffect(() => {
      if (firstInputRef.current) {
        firstInputRef.current.focus();
      }
    }, []);

    const onKeywordEndReached = () => {
      if (!skillsListRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = skillsListRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setSkillsCurrentPage(skillsCurrentPage + 1);
      }
    };
    useEffect(() => {
      if (skillsCurrentPage < Math.ceil(skillsCount / skillsPageSize)) {
        const skillsListDiv = skillsListRef.current;
        if (skillsListDiv) {
          skillsListDiv.addEventListener("scroll", onKeywordEndReached);
        }
        return () => {
          if (skillsListDiv) {
            skillsListDiv.removeEventListener("scroll", onKeywordEndReached);
          }
        };
      }
    }, [getSkillList]);
    // Update states if jobDetailsData changes dynamically
    const jobLocationsProcessed = useRef(false);

    useEffect(() => {
      if (jobDetailsData?.title) {
        setTitleText(
          jobDetailsData?.title || getSessionStorageItem("jobTitle"),
        );
      }
      setDescriptionText(
        getSessionStorageItem("jobDescription") || jobDetailsData?.description,
      );
      setAdditionalNoteText(
        getSessionStorageItem("jobAdditionalNotes") ||
          jobDetailsData?.additiionalNotes,
      );
      setExperienceMinValue(
        jobDetailsData?.minimumExperience ??
          getSessionStorageItem("minimumExperience") ??
          systemPreferenceData?.minimumExperience,
      );
      setExperienceMaxValue(
        jobDetailsData?.maximumExperience ??
          getSessionStorageItem("maximumExperience") ??
          systemPreferenceData?.maximumExperience,
      );
      setSelectedCurrency(jobDetailsData?.currencyId);
      setNoOfPositions(
        jobDetailsData?.noOfPositions ??
          getSessionStorageItem("noOfPositions") ??
          systemPreferenceData?.noOfPositions,
      );
      setMaxBudget(jobDetailsData?.maxBudget ?? null);
      setMinBudget(jobDetailsData?.minBudget ?? null);
      setJobType({
        jobType:
          getSessionStorageItem("advanceSettingData")?.jobType ??
          jobDetailsData?.jobType ??
          JobScreensEnums.JOB_TYPE_ONSITE,
        engagementType:
          getSessionStorageItem("advanceSettingData")?.engagementType ??
          jobDetailsData?.engagementType ??
          JobScreensEnums.JOB_TYPE_FULLTIME,
      });
      setAddedKeywordText(
        (getSessionStorageItem("job-keywords")?.length &&
          getSessionStorageItem("job-keywords")?.split(",")) ||
          (jobDetailsData?.keywords?.length &&
            jobDetailsData?.keywords?.split(",")) ||
          [],
      );
      setAddedSkillList(
        jobDetailsData?.jobSkills ?? getSessionStorageItem("jobSkills") ?? [],
      );
      if (jobDetailsData?.jobLocations && !jobLocationsProcessed.current) {
        jobLocationsProcessed.current = true;
        handleAddressField(transformJobDetails(jobDetailsData?.jobLocations));
      }
      if (jobDetailsData?.shiftStartTime) {
        const startTimeParts = jobDetailsData.shiftStartTime.split(" ");
        if (startTimeParts.length > 0) {
          setStartTime(startTimeParts[0]);
          if (startTimeParts.length > 1) {
            setStartMeridiem(startTimeParts[1]);
          }
        }
      }
      if (jobDetailsData?.shiftEndTime) {
        const endTimeParts = jobDetailsData.shiftEndTime.split(" ");
        if (endTimeParts.length > 0) {
          setEndTime(endTimeParts[0]);
          if (endTimeParts.length > 1) {
            setEndMeridiem(endTimeParts[1]);
          }
        }
      }
      if (jobDetailsData) {
        setEditAddressDetails({
          addressLine1: jobDetailsData?.addressLine1 || "",
          addressLine2: jobDetailsData?.addressLine2 || "",
          country: jobDetailsData?.country || "",
          state: jobDetailsData?.state || "",
          city: jobDetailsData?.city || "",
          zipcode: jobDetailsData?.zipcode || "",
        });
      }
    }, [jobDetailsData, systemPreferenceData]);
    // for skills
    useEffect(() => {
      // to get skills
      async function getSkills() {
        const industriesSkillId = localStorage.getItem("industryId") ?? "";
        const industriesSkill = await getDefaultSkill(
          industriesSkillId,
          debounceSkillSearchValue,
          skillsCurrentPage,
          skillsPageSize,
        );

        setSkillsCount(industriesSkill?.totalCount);
        const updateData = (industriesSkill?.data || [])
          .filter((item: any) => item?.questionType === "Video")
          .map((item: any) => ({
            value: item?.skillId,
            label: `${item?.skillName}`,
            ...item,
          }));
        if (searchSkillTerm?.trim()) {
          setGetSkillList(updateData);
        } else {
          setGetSkillList((prevSuggestions: any) => {
            const updatedSuggestions = [...prevSuggestions, ...updateData];
            return updatedSuggestions;
          });
        }
        setSkillLoader(false);
      }
      if (addSkillModal) {
        getSkills();
      }
    }, [debounceSkillSearchValue, addSkillModal, skillsCurrentPage]);
    useEffect(() => {
      if (showAboveInfo) {
        const formattedJobDetails = `
  <div style="font-family:Montserrat; line-height: 1.6; color: #4D4D4D;">
    <h3 style="font-size: 20px; color: #4D4D4D; margin-bottom: 16px;"><b>${titleText || ""}</b></h3>
    ${
      addedSkillList?.length
        ? `
      <div style="margin-bottom: 16px;">
        <p style="margin: 4px 0;">
          <span style="color: #4D4D4D;">${t("GENERAL.SKILLS")}:</span>
          ${addedSkillList.map((skill: any) => capitalizeFirstLetter(skill.skillName)).join(", ")}
        </p>
      </div>`
        : ""
    }

    ${
      addedKeywordText?.length
        ? `
      <div style="margin-bottom: 16px;">
        <p style="margin: 4px 0;">
          <span style="color: #4D4D4D;">${t("RESUME.SCANNING_KEYWORDS")}:</span>
          ${addedKeywordText
            ?.map((keyword: any) => capitalizeFirstLetter(keyword))
            .join(", ")}
        </p>
      </div>
    `
        : ""
    }

    <div>
      <p>
        <span style="color: #4D4D4D;">${t("RESUME.SCANNING_EXPERIENCE")}:</span> 
        ${experienceMinValue || 0} - ${experienceMaxValue || 0} ${t("GENERAL.YEARS")}
      </p>
      <p>
        <span style="color: #4D4D4D;">${t("GENERAL.OPEN")}:</span> 
        ${noOfPositions || 0}
      </p>
      <p>
        <span style="color: #4D4D4D;">${t("GENERAL.JOB_TYPE")}:</span> 
        ${typesKeyPair[jobType?.engagementType] || `${t("CREATE_ASSESSMENT.ONSITE")}`}
        
      </p>
      <p>
        <span style="color: #4D4D4D;">${t("CREATE_ASSESSMENT.ENGAGEMENT")}:</span> 
        ${typesKeyPair[jobType?.jobType] || `${t("CREATE_ASSESSMENT.FULLTIME")}`}
      </p>
      <p>
        <span style="color: #4D4D4D;">${t("RESUME.BUDGET")}:</span> 
        ${minBudget || 0} - ${maxBudget || 0}
      </p>
      <p>
        <span style="color: #4D4D4D;">${t("RESUME.SHIFT_TIMING")}: </span>
        <span>${startTime || "10:00" + startMeridiem}  - ${endTime || "7:00" + endMeridiem} </span>
      </p>
    </div>

    ${
      addressField?.length
        ? `
      <div style="margin-top: 20px;">
        <span style="color: #4D4D4D;">${t("GENERAL.LOCATION")}</span>
        <br/>
        ${addressField
          .map(
            (
              addr: any,
              index: number,
            ) => `<span style="color: #4D4D4D;">${t("GENERAL.ADDRESS")} ${index + 1}:</span>
          <p>${addr.addressLine1 || ""} ${addr.addressLine2 || ""}</p>
        `,
          )
          .join("")}
      </div>
    `
        : ""
    }

    ${
      additionalNoteText
        ? `
      <div style="margin-top: 20px;">
        <span style="color: #4D4D4D;">${t("RESUME.SCANNING_ADDITIONAL_NOTES")}</span>
        <br/>
        <p>${additionalNoteText}</p>
      </div>
    `
        : ""
    }
  </div>
`;
        setDescriptionText(formattedJobDetails);
      }
    }, [
      showAboveInfo,
      titleText,
      addedSkillList,
      experienceMinValue,
      experienceMaxValue,
      noOfPositions,
      jobType,
      addedKeywordText.length,
      addressField,
      startTime,
      endTime,
      startMeridiem,
      endMeridiem,
      additionalNoteText,
    ]);
    const handleValue = (value: number, setFn: any, name: string) => {
      setFn(value);
      setSessionStorageItem(name, value);
    };
    const handleAddedKeyword = (e: any) => {
      if (e.key === "Enter") {
        e.preventDefault(); // Prevent default form submission on Enter key
        if (keywordText.trim().length) {
          setAddedKeywordText((prev: any) => [...prev, keywordText]);
        }
        setKeywordText("");
      }
    };

    useEffect(() => {
      if (selectedCategoryIds?.length) {
        getCategoriesName();
      } else {
        setCategorySkills([]); // Clear if no category is selected
      }
    }, [selectedCategoryIds]);
    const handleAddSkills = (e: any, item?: any) => {
      if (item?.label && item?.value) {
        const alreadyExists = addedSkillList.some(
          (skill: any) => skill?.skillId === item?.value,
        );

        if (!alreadyExists) {
          setAddedSkillList((prevData: any) => [
            ...prevData,
            {
              skillName: item?.label,
              skillId: item?.value,
            },
          ]);
        }
      }

      // When clicked from getSkillsSec (API-based skill object)
      else if (item?.skillName && item?.skillId) {
        const alreadyExists = addedSkillList.some(
          (skill: any) => skill?.skillId === item?.skillId,
        );

        if (!alreadyExists) {
          setAddedSkillList((prevData: any) => [
            ...prevData,
            {
              skillName: item?.skillName,
              skillId: item?.skillId,
            },
          ]);
        }
      }

      // For input/Enter key usage
      else if (e?.key === "Enter") {
        e.preventDefault();
        const trimmedTerm = searchSkillTerm?.trim();

        if (trimmedTerm?.length) {
          const alreadyExists = addedSkillList.some(
            (skill: any) =>
              skill?.skillName?.toLowerCase() === trimmedTerm.toLowerCase(),
          );

          if (!alreadyExists) {
            setAddedSkillList((prevData: any) => [
              ...prevData,
              { skillName: trimmedTerm },
            ]);
          }
          setSearchSkillTerm("");
          setGetSkillList([]);
        }
      }
    };

    const handleDeleteAddedKeyword = (ind: number) => {
      setAddedKeywordText((prevData: any) => {
        const newData = prevData.filter(
          (_: any, index: number) => index !== ind,
        );
        return newData;
      });
    };
    const handleAddressField = (addressData: any) => {
      if (!addressData) return;

      // Create a map to track unique addresses by ID
      const addressMap = new Map();

      // First, add any existing addresses from session storage to the map
      const existingAddresses =
        getSessionStorageItem("jobMutipleAddress") || [];
      existingAddresses.forEach((addr: any) => {
        if (addr && addr.id) {
          addressMap.set(addr.id, addr);
        }
      });

      // Process new address data
      const processAddress = (data: any) => {
        if (!data) return;

        if (data.id) {
          // If address has complete data (not just an ID), update it in the map
          if (data.addressLine1) {
            addressMap.set(data.id, data);
          }
        } else {
          // Create a new address with a unique ID
          const newAddress = {
            ...data,
            id:
              Date.now().toString() +
              Math.random().toString(36).substring(2, 9),
          };
          addressMap.set(newAddress.id, newAddress);
        }
      };

      // Handle both array and single object inputs
      if (Array.isArray(addressData)) {
        // Filter out addresses that only have an ID property
        const validAddresses = addressData.filter(
          (addr) => addr && (Object.keys(addr).length > 1 || !addr.id),
        );

        validAddresses.forEach(processAddress);
      } else {
        processAddress(addressData);
      }

      // Convert map values back to array
      const updatedAddresses = Array.from(addressMap.values());

      // Update state and session storage
      setAddressField(updatedAddresses);
      setSessionStorageItem("jobMutipleAddress", updatedAddresses);
    };

    // Expose methods to the parent through the ref
    useImperativeHandle(ref, () => ({
      getUpdatedData: (status: string) => ({
        title: titleText,
        ...jobType,
        visibility: "private",
        jobId: jobDetailsData?.jobId || "",
        description: descriptionText,
        noOfPositions: Number(noOfPositions),
        minimumExperience: Number(experienceMinValue),
        maximumExperience: Number(experienceMaxValue),
        status: status,
        minBudget: minBudget ? minBudget : null,
        maxBudget: maxBudget ? maxBudget : null,
        shiftStartTime: startTime + " " + startMeridiem,
        shiftEndTime: endTime + " " + endMeridiem,
        timezone: "IST",
        additiionalNotes: additionalNoteText,
        currencyId: selectedCurrency || null,
        backgroundVerificationRequired: false,
        keywords: addedKeywordText.join(","),
        jobLocation: formatAddressField(addressField),
        jobSkills: addedSkillList ?? [],
        inclusiveTax: isTaxChecked,
      }),
      // this function are to showing error when title not enetered and scroll to that input
      scrollToTop: () => {
        titleInputRef.current?.scrollIntoView({ behavior: "smooth" });
      },
      focusTitleInput: () => {
        titleInputRef.current?.focus();
      },
      isTitleEmpty: () => {
        if (titleText?.length > 0) {
          setTitleRequire(false);
        } else {
          setTitleRequire(true);
        }
        return titleText?.length === 0;
      },
      // Add new validation function for budget
      validateBudget: () => {
        const minValue = minBudget ? parseFloat(minBudget) : null;
        const maxValue = maxBudget ? parseFloat(maxBudget) : null;

        if (
          minBudget &&
          (!/^\d+$/.test(minBudget) || !Number.isInteger(minValue))
        ) {
          showToast(t("RESUME.MIN_BUDGET_MUST_BE_INTEGER"), "error");
          return false;
        }
        if (
          maxBudget &&
          (!/^\d+$/.test(maxBudget) || !Number.isInteger(maxValue))
        ) {
          showToast(t("RESUME.MAX_BUDGET_MUST_BE_INTEGER"), "error");
          return false;
        }
        // Check if currency is selected when budget is provided
        if ((minValue !== null || maxValue !== null) && !selectedCurrency) {
          showToast(t("RESUME.CURRENCY_REQUIRED"), "error");
          return false;
        }
        // Case 1: Min budget entered but max budget is empty
        if (minValue !== null && maxValue === null) {
          showToast(t("RESUME.MAX_BUDGET_REQUIRED"), "error");
          return false;
        }
        // Case 2: Max budget entered but min budget is empty
        if (maxValue !== null && minValue === null) {
          showToast(t("RESUME.MIN_BUDGET_REQUIRED"), "error");
          return false;
        }
        // Case 3: Both values entered but min >= max
        if (minValue !== null && maxValue !== null && minValue >= maxValue) {
          showToast(t("RESUME.MIN_BUDGET_LESS_THAN_MAX"), "error");
          return false;
        }
        return true;
      },
      validateShiftTime: () =>
        validateShiftTime(startTime, startMeridiem, endTime, endMeridiem),
    }));
    const handleDeleteSkillList = (ind: number) => {
      setAddedSkillList((prevData: any) => {
        const newData = prevData.filter(
          (_: any, index: number) => index !== ind,
        );
        return newData;
      });
    };
    // useEffect to set selected skills in session storage
    useEffect(() => {
      setSessionStorageItem("jobSkills", addedSkillList);
      updateSessionStorage("jobSkills", addedSkillList);
    }, [addedSkillList]);
    useEffect(() => {
      updateSessionStorage("job-keywords", addedKeywordText?.join(","));
      setSessionStorageItem("job-keywords", addedKeywordText?.join(","));
    }, [addedKeywordText]);

    // handle remove added address
    const handleRemoveAddress = (addressIndex: number) => {
      const updatedAddresses = addressField?.filter(
        (_: any, index: number) => index !== addressIndex,
      );
      setAddressField(updatedAddresses);
      setSessionStorageItem("jobMutipleAddress", updatedAddresses);
    };
    const handleEditAddress = (addressDetail: any) => {
      setEditAddressDetails(addressDetail);
      setLocationPopupOpen(true);
      setInQueryParams(queryParams, "lp", true, navigate);
    };

    // on text editor change
    const onAdditionalNoteChange = (
      content: any,
      _delta: any,
      _source: any,
      editor: any,
    ) => {
      const currentLength = editor.getLength();
      setAdditionalNoteText(content);
      setCountAdditionalNoteInEditor(currentLength);
      setAdditionalCountManageFlag(true);
      setSessionStorageItem("jobAdditionalNotes", content);
    };
    // desctiption text change function
    const onDescriptionChange = (
      content: any,
      _delta: any,
      _source: any,
      editor: any,
    ) => {
      const currentLength = editor.getLength();
      setDescriptionText(content);
      setCountDescriptionInEditor(currentLength);
      setDescriptionCountManageFlag(true);
      setSessionStorageItem("jobDescription", content);
      if (currentLength === 1) {
        setShowAboveInfo(false);
      }
    };
    // get currency list
    useEffect(() => {
      getCurrencyListApi();
    }, []);
    const getCurrencyListApi = async () => {
      const res: any = await getCurrencyList();
      if (res?.data) {
        const formatted = res?.data.map((item: any) => ({
          value: item.currencyId,
          label: item.code,
        }));
        setCurrencyList(formatted);
      }
    };
    useEffect(() => {
      if (addSkillModal) {
        getCategoriesName();
      }
    }, [
      selectedCategoryIds,
      debounceSkillSearchValue,
      addSkillModal,
      categoryCurrentPage,
    ]);

    const getCategoriesName = async () => {
      setSkillLoader(true);
      const getPartnerList: any = await getIndustrySkillMapping(
        selectedCategoryIds, // categoryIds
        debounceSkillSearchValue, // search
        categoryCurrentPage, // categoryCurrentPage
        categoryPageSize, // categoryPageSize
      );
      if (getPartnerList?.status === 200) {
        setCategory(getPartnerList?.data?.categoryList);
        setCategorySkills(
          getPartnerList?.data?.skillList?.data.filter(
            (item: any) => item?.questionType === "Video",
          ),
        );
      }
      setSkillLoader(false);
    };

    const handleCheckboxChange = (id: string) => {
      setCategoryCurrentPage(1);
      setSelectedCategoryIds(
        (prevSelectedIds: any) =>
          prevSelectedIds.includes(id)
            ? prevSelectedIds.filter((selectedId: string) => selectedId !== id) // remove if already selected
            : [...prevSelectedIds, id], // add if not selected
      );
    };

    return (
      <div className="scanningDetails" ref={scrollingRef}>
        <div className="generateTitleText">
          <label className="titleLabel comLabel">{t("RESUME.JOB_TITLE")}</label>
          <div ref={titleInputRef}>
            <InputField
              value={capitalizeFirstLetter(titleText)}
              onChange={(e: any) => {
                setTitleText(e);
                setSessionStorageItem("jobTitle", e);
                if (e) {
                  setTitleRequire(false);
                }
                if (e?.length === 0) {
                  setTitleRequire(true);
                }
              }}
              placeholder={t("RESUME.JOB_TITLE")}
              additionalProps={{
                className: "textInput",
                ref: firstInputRef,
              }}
            />
            {titleRequire && (
              <div className="errorMessage">
                {t("ERROR.JOB_TITLE_REQUIRED")}
              </div>
            )}
          </div>
        </div>
        <div className="horizontalLine mb-3"></div>
        <div className="skillExtracted">
          <div>
            <span className="extractedSkill comLabel d-flex">
              {t("GENERAL.SKILLS")}
              <div className="skillAddBtn">
                <AssessmentButton
                  onClick={() => {
                    setSkillsCurrentPage(1);
                    setCategoryCurrentPage(1);
                    setGetSkillList([]);
                    setAddSkillModal(true);
                  }}
                >
                  <PlusIcon />
                  {t("RESUME.SCANNING_ADD_SKILLS")}
                </AssessmentButton>
              </div>
            </span>
            <div className="skillsSuggestionSec">
              {addSkillModal && (
                <RightSidePanel
                  show={true}
                  handleClose={() => setAddSkillModal(false)}
                  title={t("RESUME.SCANNING_ADD_SKILLS")}
                  className="rightSidePanelSection changePasswordPanel"
                >
                  <div>
                    <div className="inputWithSuggestion">
                      <TemplateSearch
                        handleKeyPress={(e: any) => {
                          handleAddSkills(e);
                        }}
                        placeholder={t("GENERAL.SEARCH_SKILLS")}
                        iconName="searchList"
                        additionalProps={{ className: "skillSearchInput" }}
                        value={searchSkillTerm}
                        onChange={(value: any) => {
                          setCategoryCurrentPage(1);
                          setSkillLoader(true);
                          setSkillsCurrentPage(1);
                          setSearchSkillTerm(value);
                          if (value?.trim()?.length === 0) {
                            setGetSkillList([]);
                          }
                        }}
                      />

                      <div className="addedSkillWrapper">
                        {addedSkillList?.map((item: any, ind: number) => {
                          return (
                            <div key={ind} className="word">
                              <span>{item?.skillName}</span>
                              <div
                                onClick={() => handleDeleteSkillList(ind)}
                                className="deleteKeyword"
                              >
                                <CircleCrossIcon
                                  color="var(--primary-white)"
                                  width="16px"
                                  height="16px"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="categoryAccordion mt-3">
                      <div
                        className="accordion"
                        id="accordionPanelsStayOpenExample"
                      >
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#panelsStayOpen-collapseOne"
                              aria-expanded="false"
                              aria-controls="panelsStayOpen-collapseOne"
                            >
                              {t("CREATE_ASSESSMENT.GLOBAL_CATEGORY")}
                              <span>
                                <DownArrow />
                              </span>
                            </button>
                          </h2>
                          <div
                            id="panelsStayOpen-collapseOne"
                            className="accordion-collapse collapse"
                          >
                            <div className="accordion-body">
                              {category?.map((list: any, key: any) => (
                                <div
                                  key={key}
                                  className="technicalSec"
                                  onClick={() =>
                                    handleCheckboxChange(list?.skillsCategoryId)
                                  }
                                >
                                  <AssessmentCheckboxRadio
                                    type="checkbox"
                                    checked={selectedCategoryIds.includes(
                                      list?.skillsCategoryId,
                                    )}
                                  />
                                  <label>
                                    {list?.categoryName}
                                    <span className="skillCount">
                                      ({list?.totalSkill})
                                    </span>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="getSkillsSec" ref={skillsListRef}>
                      <h4>{t("GENERAL.SKILLS")}</h4>
                      {skillLoader ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <Loader />
                        </div>
                      ) : (selectedCategoryIds.length
                          ? categorySkills
                          : getSkillList
                        )?.length ? (
                        (selectedCategoryIds.length
                          ? categorySkills
                          : getSkillList
                        )?.map((item: any, index: number) => {
                          const isAlreadyAdded = addedSkillList.some(
                            (skill: any) => skill?.skillId === item?.skillId,
                          );

                          return (
                            <div className="getSkillsWrap" key={index}>
                              <span>{item?.skillName}</span>
                              <div className={isAlreadyAdded ? "added" : "add"}>
                                <AssessmentButton
                                  onClick={(e) => {
                                    handleAddSkills(e, item);
                                  }}
                                  disabled={isAlreadyAdded}
                                >
                                  {isAlreadyAdded
                                    ? t("GENERAL.ADDED")
                                    : t("GENERAL.ADD")}
                                </AssessmentButton>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <DataNotAvailable />
                      )}
                    </div>
                  </div>
                </RightSidePanel>
              )}
            </div>
            <div className="addedSkillWrapper">
              {addedSkillList?.map((item: any, ind: number) => {
                return (
                  <div key={ind} className="word">
                    <span>{item?.skillName}</span>
                    <div
                      onClick={() => handleDeleteSkillList(ind)}
                      className="deleteKeyword"
                    >
                      <CircleCrossIcon
                        color="var(--primary-white)"
                        width="16px"
                        height="16px"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="horizontalLine"></div>
        <div className="keywords mt-4 mb-5">
          <div className="titleIcon">
            <span className="comLabel">
              {t("RESUME.SCANNING_ADD_KEYWORDS")}
            </span>
            <div className="iIcon">
              <Tooltip
                classname="tooltipOverCss"
                text={t(t("RESUME.ASSESSMENT_YOU_CAN_ADD_OWN_KEYWORDS"))}
              />
            </div>
          </div>

          <div className="generateKeywordText">
            <InputField
              value={keywordText}
              onChange={(e: any) => setKeywordText(e)}
              placeholder={t("RESUME.SCANNING_KEYWORDS")}
              additionalProps={{
                className: "textInput",
              }}
              handleKeyPress={(e: any) => {
                if (e.target.value) {
                  handleAddedKeyword(e);
                }
              }}
            />
          </div>
          <div className="sarchedKeyword mt-3">
            {addedKeywordText?.map((item: any, ind: number) => {
              return (
                <div key={ind} className="word">
                  <span>{item}</span>
                  <div
                    onClick={() => handleDeleteAddedKeyword(ind)}
                    className="deleteKeyword"
                  >
                    <CircleCrossIcon
                      color="var(--primary-white)"
                      width="16px"
                      height="16px"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="horizontalLine"></div>
        {/* row 1 */}
        <div className="rangeCss">
          <div className="childSection">
            <MultiSelector
              id="on234dds324ccsfsdf4e"
              label={`${t("RESUME.SCANNING_EXPERIENCE")}`}
              minLabel="0"
              maxLabel="60"
              min={0}
              max={60}
              value={experienceMinValue}
              setValue={(value) => {
                handleValue(value, setExperienceMinValue, "minimumExperience");
                updateSessionStorage("minimumExperience", value);
              }}
              maxValue={experienceMaxValue}
              setMaxValue={(value) => {
                handleValue(value, setExperienceMaxValue, "maximumExperience");
                updateSessionStorage("maximumExperience", value);
              }}
            />
          </div>
          <div className="typeCss">
            <EngagementType setJobType={setJobType} jobType={jobType} />
          </div>
        </div>
        {/* row 2 */}
        <div className="rangeCss">
          <div className="childSection">
            <RangeSelector
              id="two6547b434dgtrb4564"
              label={`${t("RESUME.SCANNING_OPEN_POSITIONS")}`}
              minLabel={"01"}
              maxLabel={500}
              step={1}
              min={1}
              max={500}
              value={noOfPositions}
              setValue={(value) => {
                handleValue(value, setNoOfPositions, "noOfPositions");
                updateSessionStorage("noOfPositions", value);
              }}
            />
          </div>
          <div className="typeCss">
            <JobTypeSelector setJobType={setJobType} jobType={jobType} />
          </div>
        </div>
        {/* row 3 */}
        <div className="rangeCss mt-4 align-items-start">
          <div className="budgetCompo">
            <Budget
              isTaxChecked={isTaxChecked}
              setIsTaxChecked={setIsTaxChecked}
              setMaxBudget={setMaxBudget}
              setMinBudget={setMinBudget}
              minBudget={minBudget}
              maxBudget={maxBudget}
              currencyList={currencyList}
              handleCurrencyChange={(e) => {
                setSelectedCurrency(e);
              }}
              selectedCurrency={selectedCurrency}
            />
          </div>
          <div className="typeCss">
            <ShiftTime
              startMeridiem={startMeridiem}
              endMeridiem={endMeridiem}
              onStartTimeChange={(e: any) => {
                setStartTime(e);
                setSessionStorageItem("jobShiftStartTime", e);
              }}
              onEndTimeChange={(e: any) => {
                setEndTime(e);
                setSessionStorageItem("jobShiftEndTime", e);
              }}
              onStartMeridiemChange={(e: any) => {
                setStartMeridiem(e);
                setSessionStorageItem("jobShiftStartMeridiem", e);
              }}
              onEndMeridiemChange={(e: any) => {
                setEndMeridiem(e);
                setSessionStorageItem("jobShiftEndMeridiem", e);
              }}
              startTime={startTime}
              endTime={endTime}
            />
          </div>
        </div>
        <div className="horizontalLine"></div>
        {jobType?.jobType !== JobScreensEnums.JOB_TYPE_REMOTE && (
          <>
            <div className="locationSection">
              <div className="addressFieldForm mt-5">
                <span className="location comLabel">
                  {t("RESUME.SCANNING_LOCATION")}
                </span>
                <div>
                  <AssessmentButton
                    onClick={() => {
                      setInQueryParams(queryParams, "lp", true, navigate);
                      setLocationPopupOpen(true);
                    }}
                    className={"addLocationBtn"}
                  >
                    <PlusIcon />
                    {t("RESUME.ADD_LOCATION")}
                  </AssessmentButton>
                </div>
              </div>
              <div className="row mt-3">
                {addressField?.map((item: any, index: any) => {
                  return (
                    <div className="col-md-4 col-sm-6 mb-3" key={index}>
                      <div className="locationCard">
                        <div className="addedLocationTop">
                          <span>{t("RESUME.SCANNING_LOCATION")}</span>
                          <div
                            className="crossIcon"
                            onClick={() => {
                              handleRemoveAddress(index);
                            }}
                          >
                            <CircleCrossIcon color="var(--light-black)" />
                          </div>
                        </div>
                        <div
                          className="addressText pointerCursor"
                          onClick={() => handleEditAddress(item)}
                        >
                          <span>{item?.addressLine1}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="horizontalLine mt-5"></div>
          </>
        )}
        {/* additional notes section */}
        <div className="additionalNotesSec mt-5">
          <p className="additionalNotesTitle comLabel">
            {t("RESUME.SCANNING_ADDITIONAL_NOTES")}
          </p>
          <TextEditor
            value={additionalNoteText}
            onChange={onAdditionalNoteChange}
            placeholder={t("GENERAL.Type_HERE")}
          />
          <div className="textEditorMsg">
            <p className="errorMessage">
              {countAdditionalNoteInEditor > textEditorLimit && (
                <>
                  {t("GENERAL.MUST_BE_LESS_THAN")} {textEditorLimit - 1}{" "}
                  {t("GENERAL.CHARACTERS")}
                </>
              )}
            </p>
            {(additionalCountManageFlag ? 1 : textEditorLimit) <
              countAdditionalNoteInEditor && (
              <p className="limitMsg">
                {calculateMinusAmount(
                  countAdditionalNoteInEditor,
                  textEditorLimit,
                )}{" "}
                {t("CREATE_ASSESSMENT.TEXT_EDITOR_LIMIT")}
              </p>
            )}
          </div>
        </div>
        <div className="horizontalLine mt-5"></div>
        {/* job description sec */}
        <div className="description mt-5">
          <div className="descriptionTitleSec">
            <p className="descriptionTitle comLabel">
              {t("RESUME.SCANNING_JOB_DESCRIPTION")}
            </p>
            <AssessmentButton
              className={"whiteBtn"}
              onClick={() => setShowAboveInfo(true)}
            >
              {t("RESUME.CREATE_JOB_FROM_ABOVE")}
            </AssessmentButton>
          </div>
          <TextEditor
            value={descriptionText}
            onChange={onDescriptionChange}
            placeholder={t("GENERAL.Type_HERE")}
          />
          <div className="textEditorMsg">
            <p className="errorMessage">
              {countDescriptionInEditor > jobDescriptionLimit && (
                <>
                  {t("GENERAL.MUST_BE_LESS_THAN")} {jobDescriptionLimit - 1}{" "}
                  {t("GENERAL.CHARACTERS")}
                </>
              )}
            </p>
            {(descriptionCountManageFlag ? 1 : jobDescriptionLimit) <
              countDescriptionInEditor && (
              <p className="limitMsg">
                {calculateMinusAmount(
                  countDescriptionInEditor,
                  jobDescriptionLimit,
                )}{" "}
                {t("CREATE_ASSESSMENT.TEXT_EDITOR_LIMIT")}
              </p>
            )}
          </div>
        </div>
        {/* add locations popup */}
        <CustomModal
          scrollable
          className="locationPopup"
          show={locationPopupOpen}
          isCrossBtn={true}
          isHeaderVisible={false}
          handleClose={() => {
            setEditAddressDetails({});
            setLocationPopupOpen(false);
            removeFromQueryParams(queryParams, "lp", navigate);
          }}
          isFooterVisible={false}
        >
          <AddressField
            addressField={editAddressDetails}
            handleAddressField={handleAddressField}
            setLocationPopupOpen={setLocationPopupOpen}
            setEditAddressDetails={setEditAddressDetails}
          />
        </CustomModal>
      </div>
    );
  },
);
ScanningDetails.displayName = "ScanningDetails";
export default ScanningDetails;
